@if (!disabled) {
  <button matRipple class="minus-button" (dtDynamicChange)="minusButton()" [disabled]="minusDisabled">&ndash;</button>
}
<ng-content></ng-content>
@if (!disabled) {
  <button matRipple class="plus-button" (dtDynamicChange)="plusButton()" [disabled]="plusDisabled">+</button>
}
